export const RAPID_BETS_UPDATE_BET = 'RAPID_BETS_UPDATE_BET'
export const RAPID_BETS_REMOVE_BET = 'RAPID_BETS_REMOVE_BET'
export const RAPID_BETS_SYNC_NUMBERS = 'RAPID_BETS_SYNC_NUMBERS'
export const RAPID_BETS_CLEAR_ALL = 'RAPID_BETS_CLEAR_ALL'

export const RAPID_BETS_UPDATE_MODAL_SELECTION = 'RAPID_BETS_UPDATE_MODAL_SELECTION'
export const RAPID_BETS_UPDATE_MODAL_BONUS_SELECTION = 'RAPID_BETS_UPDATE_MODAL_BONUS_SELECTION'
